const FILE_TYPES = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],
};

const CONFIG = {
  FILE_TYPES,
  FILE_SIZE_LIMIT: 20 * 1024 * 1024, // 20MB
} as const;

export default CONFIG;
